import * as f from '../../components/BPMTable/BPMInputs';
import { DataTransformer, FormFieldDescription, FormSection } from '../../components/BPMTable/TableMapperCreator';
import { getTodayDateString, parsePlainDate } from '../../utils/DateUtils';
import FormCreatorCreator from '../../components/BPMTable/FormCreatorFactory/FormCreatorCreator';
import BayphoneUserMinimalTable from '../../pages/Bayphone/BayphoneUserMinimalTable';
import formCreatorCreatorFactoryCreators from '../../components/BPMTable/FormCreatorFactory/FormCreatorCreatorFactoryCreator';
import { bayphoneQueries } from './BayphoneTableDefinitions';

const allBayphoneDeviceTypes = `
    allBayphoneDeviceTypes {
        id
        name
    }
`

const AllBayphoneChangeReasons = `
	allBayphoneChangeReasons {
        id
        name
    }
`

const AllBayphoneCloseReasons = `
    allBayphoneCloseReasons {
        id
        name
    }
`

const allBayphoneOnHoldReasons = `
    allBayphoneOnHoldReasons {
        id
        name
    }
` 

class BayphoneFormCreator extends FormCreatorCreator {
  constructor() {
        super()
  }

  static getId = () => {
        return "BayphoneFormCreator"
    }

  getFormCreator = () => {
        const formCreator = this.createFormCreator(this.constructor.getId(), 'Bayphone', bayphoneQueries)
        const bayphonUserTablePicker = new BayphoneUserMinimalTable({first: 15, orderDirection: "asc", orderField: "firstName", isActive:true})

    //New/Edit Form Sections
        const userSection = new FormSection('User', 1)
        const changeSection = new FormSection('Change Detail', 2)
        const observationsSection = new FormSection('Observations', 3)

    formCreator.addInputs([
      new FormFieldDescription(
        'user',
        new f.InputDescription(new f.ModelCreator('user', bayphonUserTablePicker), true, new f.RequiredValidator(1)),
        userSection,
        1,
                { label: 'User', transform: new DataTransformer(data=> data, data=> data), modificationReadOnly: true }
      ),
      new FormFieldDescription(
        'deviceType',
                new f.InputDescription(new f.DropDownCreator("deviceType"), true, new f.RequiredValidator(1)),
        changeSection,
        1,
        {
          label: 'Device Type',
          queryAllDropdownOptions: allBayphoneDeviceTypes,
          transform: new DataTransformer(data => data.name),
          modificationReadOnly: true,
        }
      ),
      new FormFieldDescription(
        'changeReason',
        new f.InputDescription(new f.DropDownCreator('changeReason'), true, new f.RequiredValidator(1)),
        changeSection,
        2,
        {
          label: 'Change reason',
                    queryAllDropdownOptions:
                    AllBayphoneChangeReasons,
          transform: new DataTransformer(data => data.name),
          modificationReadOnly: true,
        }
      ),
      new FormFieldDescription(
        'validSince',
        new f.InputDescription(
          new f.DateCreator('validSince', getTodayDateString()),
          true,
                    new f.CompositeValidator([
                        new f.RequiredValidator(1),
                        new f.MinDateValidator()
                    ])
        ),
        changeSection,
        3,
        {
          label: 'Valid since',
          modificationReadOnly: true,
        }
      ),
      new FormFieldDescription(
        'expirationDate',
        new f.InputDescription(
          new f.DateCreator('expirationDate', getTodayDateString()),
          true,
          new f.CompositeValidator([
            new f.RequiredValidator(1),
            new f.MinDateValidator(),
            new f.FunctionContextualComparisonValidator(
              'validSince',
              (a, b) => parsePlainDate(a) > parsePlainDate(b),
              '{{field}} must be after {{otherField}}',
              'Valid since'
            ),
          ])
        ),
        changeSection,
        4,
        {
          label: 'Expiration Date',
          modificationReadOnly: true,
        }
      ),
      new FormFieldDescription(
        'observation',
        new f.InputDescription(new f.TextAreaCreator('observation'), false),
        observationsSection,
        1,
        { label: 'Observation' }
      ),
    ]);

    return formCreator;
    }
}

formCreatorCreatorFactoryCreators.addFormCreatorCreator(BayphoneFormCreator)

export default BayphoneFormCreator